import { Building, Users, Target, Star, Briefcase, DollarSign, Sparkles, Award, PhoneCall, Mail, MessageSquare, Calendar, MapPin } from 'lucide-react';

export const API = process.env.REACT_APP_BACKEND_URL;

export const SECTEURS = {
  entreprise: { label: 'Entreprises / PME', icon: Building, color: '#3B82F6' },
  ce: { label: 'CSE / CE', icon: Users, color: '#8B5CF6' },
  seminaire: { label: 'Seminaires / Events', icon: Target, color: '#F59E0B' },
  famille: { label: 'Mariages / Fetes', icon: Star, color: '#EC4899' },
  remorque: { label: 'Marches / Festivals', icon: Briefcase, color: '#B45309' },
  restaurant: { label: 'Groupes / Touristes', icon: Users, color: '#009893' },
  mairie: { label: 'Mairies / Collectivites', icon: Building, color: '#6366F1' },
  association: { label: 'Associations / Clubs', icon: Users, color: '#14B8A6' },
  ecole: { label: 'Ecoles / Formation', icon: Award, color: '#F97316' },
  transport: { label: 'Transport / Auto', icon: Briefcase, color: '#0EA5E9' },
  immobilier: { label: 'Immobilier / BTP', icon: Building, color: '#6D28D9' },
  bienetre: { label: 'Bien-etre / Sante', icon: Star, color: '#D946EF' },
  banque: { label: 'Banque / Finance', icon: DollarSign, color: '#059669' },
  evenement: { label: 'Evenementiel', icon: Sparkles, color: '#E11D48' },
  commerce: { label: 'Commerce', icon: Briefcase, color: '#CA8A04' },
  services: { label: 'Services / Conseil', icon: Users, color: '#475569' },
};

export const STATUTS = {
  nouveau: { label: 'Nouveau', color: '#94A3B8', order: 0 },
  contacte: { label: 'Contacte', color: '#3B82F6', order: 1 },
  relance: { label: 'Relance', color: '#F59E0B', order: 2 },
  repondu: { label: 'Repondu', color: '#8B5CF6', order: 3 },
  rdv: { label: 'RDV', color: '#009893', order: 4 },
  devis: { label: 'Devis', color: '#C9A84C', order: 5 },
  gagne: { label: 'Gagne', color: '#10B981', order: 6 },
  perdu: { label: 'Perdu', color: '#EF4444', order: 7 },
};

export const PRIORITES = {
  haute: { label: 'Haute', color: '#EF4444' },
  moyenne: { label: 'Moyenne', color: '#F59E0B' },
  basse: { label: 'Basse', color: '#94A3B8' },
};

export const ZONES = {
  '66': {
    label: 'Pyrenees-Orientales (66)',
    villes: [
      'Saint-Laurent-de-la-Salanque', 'Perpignan', 'Canet-en-Roussillon',
      'Rivesaltes', 'Torreilles', 'Le Barcares', 'Claira', 'Pia',
      'Salses-le-Chateau', 'Saint-Esteve', 'Thuir', 'Elne', 'Argeles-sur-Mer',
      'Collioure', 'Banyuls-sur-Mer', 'Ceret', 'Prades', 'Saint-Cyprien',
      'Port-Vendres', 'Le Soler', 'Cabestany', 'Pollestres', 'Toulouges',
      'Bompas', 'Saleilles', 'Alenya', 'Ille-sur-Tet', 'Millas',
      'Font-Romeu', 'Bourg-Madame', 'Saillagouse',
    ],
  },
  '11': {
    label: 'Aude (11)',
    villes: [
      'Narbonne', 'Carcassonne', 'Lezignan-Corbieres', 'Leucate',
      'Port-la-Nouvelle', 'Sigean', 'Gruissan', 'Limoux',
      'Castelnaudary', 'Quillan', 'Coursan', 'Trebes',
    ],
  },
  '34': {
    label: 'Herault (34)',
    villes: [
      'Beziers', 'Montpellier', 'Agde', 'Sete', 'Lunel',
      'Pezenas', 'Lodeve', 'Frontignan', 'Meze',
      'Marseillan', 'Valras-Plage', 'Cap d\'Agde',
    ],
  },
};

export const ALL_ZONES_FLAT = [
  ...ZONES['66'].villes,
  ...ZONES['11'].villes,
  ...ZONES['34'].villes,
];

export const MOCK_DATA = {
  entreprise: [
    { nom: 'AGRI SUD ROUSSILLON', contact: 'M. Durand', poste: 'DG', email: 'contact@agrisud66.fr', tel: '04 68 12 34 56', ville: 'Perpignan', size: '45 sal.', source: 'gmaps', note: '4.2' },
    { nom: 'BTP ROUSSILLON TRAVAUX', contact: 'Mme Blanc', poste: 'PDG', email: 'info@btproussillon.com', tel: '04 68 45 67 89', ville: 'Rivesaltes', size: '30 sal.', source: 'gmaps', note: '3.8' },
    { nom: 'TRANSPORT CATALAN LOGISTIQUE', contact: 'M. Garcia', poste: 'DG', email: 'contact@tclogistique.fr', tel: '04 68 56 78 90', ville: 'Perpignan', size: '80 sal.', source: 'gmaps', note: '4.0' },
    { nom: 'PERPIGNAN TECH SERVICES', contact: 'Mme Rousseau', poste: 'DSI', email: 'rh@perpignantech.fr', tel: '04 68 67 89 01', ville: 'Perpignan', size: '25 sal.', source: 'gmaps', note: '4.5' },
    { nom: 'SAS VINS DU ROUSSILLON', contact: 'M. Calvet', poste: 'Gerant', email: 'contact@vinsroussillon.fr', tel: '04 68 55 44 33', ville: 'Rivesaltes', size: '15 sal.', source: 'gmaps', note: '4.3' },
    { nom: 'GARAGE CATALAN AUTO', contact: 'M. Planes', poste: 'Directeur', email: 'direction@catalanauto.fr', tel: '04 68 28 91 02', ville: 'Saint-Laurent-de-la-Salanque', size: '12 sal.', source: 'gmaps', note: '4.1' },
  ],
  ce: [
    { nom: 'CSE MAIRIE DE PERPIGNAN', contact: 'M. Fabre', poste: 'President CSE', email: 'cse@mairie-perpignan.fr', tel: '04 68 61 62 63', ville: 'Perpignan', size: '600 agents', source: 'gmaps' },
    { nom: 'CE SNCF PERPIGNAN', contact: 'Mme Martin', poste: 'Secretaire CE', email: 'ce.perpignan@sncf.fr', tel: '04 68 35 48 21', ville: 'Perpignan', size: '320 agents', source: 'gmaps' },
    { nom: 'CSE CENTRE HOSPITALIER', contact: 'M. Petit', poste: 'Elu CSE', email: 'cse@ch-perpignan.fr', tel: '04 68 61 66 33', ville: 'Perpignan', size: '2000 agents', source: 'gmaps' },
    { nom: 'CE EDF PERPIGNAN', contact: 'Mme Duval', poste: 'Tresoriere CE', email: 'ce.perpignan@edf.fr', tel: '04 68 55 22 11', ville: 'Perpignan', size: '150 agents', source: 'gmaps' },
  ],
  famille: [
    { nom: 'DOMAINE DE LA GARRIGUE BLEUE', contact: 'Mme Pons', poste: 'Responsable', email: 'contact@garriguebleue.fr', tel: '04 68 73 12 34', ville: 'Rivesaltes', size: '150 pers.', source: 'gmaps', note: '4.7' },
    { nom: 'MAS DES VIGNES', contact: 'M. Roig', poste: 'Proprietaire', email: 'reception@masdesvignes66.fr', tel: '04 68 64 55 66', ville: 'Perpignan', size: '200 pers.', source: 'gmaps', note: '4.4' },
    { nom: 'CHATEAU ROUSSILLON RECEPTIONS', contact: 'Mme Serra', poste: 'Coordinatrice', email: 'events@chateauroussillon.fr', tel: '04 68 51 23 45', ville: 'Perpignan', size: '250 pers.', source: 'gmaps', note: '4.6' },
  ],
  remorque: [
    { nom: 'MARCHE DE CANET-EN-ROUSSILLON', contact: 'Service animations', poste: '', email: 'animations@mairie-canet.fr', tel: '04 68 86 72 00', ville: 'Canet-en-Roussillon', source: 'pj' },
    { nom: 'FETE DE LA SAINT-JEAN PERPIGNAN', contact: 'Service evenements', poste: '', email: 'evenements@mairie-perpignan.fr', tel: '04 68 66 30 66', ville: 'Perpignan', source: 'pj' },
    { nom: 'FESTIVAL MEDITERRANEE LEUCATE', contact: 'Association organisatrice', poste: '', email: 'contact@festival-leucate.fr', tel: '04 68 40 91 31', ville: 'Leucate', source: 'pj' },
  ],
  seminaire: [
    { nom: 'HOTEL NEMO PERPIGNAN', contact: 'M. Torres', poste: 'Resp. seminaires', email: 'seminaires@hotelnemo.fr', tel: '04 68 35 14 14', ville: 'Perpignan', size: '120 places', source: 'gmaps', note: '4.1' },
    { nom: 'DOMAINE RIBERACH', contact: 'Mme Vidal', poste: 'Directrice', email: 'events@riberach.com', tel: '04 68 56 78 90', ville: 'Rivesaltes', size: '80 places', source: 'gmaps', note: '4.8' },
  ],
  mairie: [
    { nom: 'MAIRIE DE SAINT-LAURENT', contact: 'M. le Maire', poste: 'Maire', email: 'mairie@saintlaurent66.fr', tel: '04 68 28 31 15', ville: 'Saint-Laurent-de-la-Salanque', source: 'pj' },
    { nom: 'MAIRIE DE TORREILLES', contact: 'Mme Adjoint', poste: 'Adjointe culture', email: 'mairie@torreilles.fr', tel: '04 68 28 40 51', ville: 'Torreilles', source: 'pj' },
    { nom: 'MAIRIE DE CLAIRA', contact: 'M. Premier adjoint', poste: '1er adjoint', email: 'mairie@claira.fr', tel: '04 68 28 09 10', ville: 'Claira', source: 'pj' },
  ],
  association: [
    { nom: 'RUGBY CLUB SAINT-LAURENT', contact: 'M. Planes', poste: 'President', email: 'contact@rugbysl66.fr', tel: '06 12 34 56 78', ville: 'Saint-Laurent-de-la-Salanque', size: '120 membres', source: 'pj' },
    { nom: 'LIONS CLUB PERPIGNAN', contact: 'Mme Jourdan', poste: 'Presidente', email: 'perpignan@lionsclub.fr', tel: '06 23 45 67 89', ville: 'Perpignan', size: '45 membres', source: 'pj' },
    { nom: 'ROTARY CLUB PERPIGNAN', contact: 'M. Verdier', poste: 'President', email: 'perpignan@rotary.fr', tel: '06 78 90 12 34', ville: 'Perpignan', size: '55 membres', source: 'pj' },
  ],
  ecole: [
    { nom: 'IUT PERPIGNAN', contact: 'M. Directeur', poste: 'Directeur', email: 'direction@iut-perpignan.fr', tel: '04 68 66 24 00', ville: 'Perpignan', size: '800 etudiants', source: 'pj' },
    { nom: 'LYCEE ARAGO', contact: 'Mme Proviseur', poste: 'Proviseure', email: 'ce.0660010b@ac-montpellier.fr', tel: '04 68 66 33 90', ville: 'Perpignan', size: '1200 eleves', source: 'pj' },
  ],
  restaurant: [
    { nom: 'OFFICE TOURISME PERPIGNAN', contact: 'Mme Tourisme', poste: 'Directrice', email: 'contact@perpignantourisme.com', tel: '04 68 66 30 30', ville: 'Perpignan', source: 'gmaps', note: '4.3' },
    { nom: 'SENIOR CLUB CANET', contact: 'M. Responsable', poste: 'Animateur', email: 'seniors@mairie-canet.fr', tel: '04 68 86 72 10', ville: 'Canet-en-Roussillon', size: '200 membres', source: 'pj' },
  ],
};

export const COMM_TYPES = [
  { id: 'appel', label: 'Appel', icon: PhoneCall },
  { id: 'email', label: 'Email', icon: Mail },
  { id: 'sms', label: 'SMS', icon: MessageSquare },
  { id: 'rdv', label: 'RDV', icon: Calendar },
  { id: 'visite', label: 'Visite', icon: MapPin },
];

export const RESULTATS_APPEL = [
  { value: 'interesse', label: 'Interesse', color: '#10B981', auto: 'contacte' },
  { value: 'a rappeler', label: 'A rappeler', color: '#F59E0B', auto: 'relance' },
  { value: 'rdv fixe', label: 'RDV fixe', color: '#009893', auto: 'rdv' },
  { value: 'devis envoye', label: 'Devis envoye', color: '#C9A84C', auto: 'devis' },
  { value: 'gagne', label: 'Gagne / Signe', color: '#10B981', auto: 'gagne' },
  { value: 'pas interesse', label: 'Pas interesse', color: '#EF4444', auto: 'perdu' },
  { value: 'absent', label: 'Absent / Repondeur', color: '#94A3B8', auto: null },
  { value: 'autre', label: 'Autre', color: '#64748B', auto: null },
];

export const PROCHAINES_ACTIONS = [
  { value: '', label: 'Aucune' },
  { value: 'j+3', label: 'Rappeler dans 3 jours' },
  { value: 'j+7', label: 'Rappeler dans 1 semaine' },
  { value: 'j+14', label: 'Rappeler dans 2 semaines' },
  { value: 'j+30', label: 'Rappeler dans 1 mois' },
];

// ══════ SMALL REUSABLE COMPONENTS ══════

export const StatutBadge = ({ statut, onClick, size = 'sm' }) => {
  const s = STATUTS[statut] || STATUTS.nouveau;
  const cls = size === 'xs' ? 'text-[9px] px-1.5 py-0.5' : 'text-[10px] px-2 py-0.5';
  return (
    <button onClick={onClick} className={`${cls} font-bold rounded-full uppercase tracking-wider whitespace-nowrap`}
      style={{ background: s.color + '18', color: s.color, border: `1px solid ${s.color}30` }}
      data-testid={`statut-${statut}`}>
      {s.label}
    </button>
  );
};

export const SecteurTag = ({ secteur }) => {
  const s = SECTEURS[secteur] || {};
  const Icon = s.icon || Building;
  return (
    <span className="text-[10px] px-2 py-0.5 rounded-full inline-flex items-center gap-1" style={{ background: (s.color || '#666') + '12', color: s.color || '#666' }}>
      <Icon size={10} /> {(s.label || secteur).split('/')[0]}
    </span>
  );
};

export const ScoreBadge = ({ score }) => {
  if (!score) return null;
  const color = score >= 75 ? '#10B981' : score >= 50 ? '#F59E0B' : '#EF4444';
  return <span className="text-[10px] font-mono font-bold px-1.5 py-0.5 rounded" style={{ background: color + '15', color }}>{score}</span>;
};

export const PriorityDot = ({ priorite }) => {
  const p = PRIORITES[priorite] || PRIORITES.moyenne;
  return <span className="w-2 h-2 rounded-full inline-block" style={{ background: p.color }} title={p.label} />;
};

// ══════ Contextual Coaching Tips ══════
export function generateContextTips(prospect, comms, lastComm) {
  const statut = prospect.statut;
  const nbComms = comms.length;
  const nom = prospect.contact || prospect.nom;
  const secteur = prospect.secteur || 'entreprise';
  const lastDate = lastComm?.date ? new Date(lastComm.date) : null;
  const daysSince = lastDate ? Math.floor((Date.now() - lastDate.getTime()) / 86400000) : null;
  const lastResult = lastComm?.resultat;
  const lastNotes = lastComm?.notes;

  const tips = { contexte: '', conseils: [], ouverture: '', erreurs: [] };

  if (statut === 'relance') {
    tips.contexte = `RELANCE — ${nbComms} echange${nbComms > 1 ? 's' : ''} precedent${nbComms > 1 ? 's' : ''}`;
    if (daysSince !== null) {
      tips.contexte += ` (dernier il y a ${daysSince}j)`;
    }

    if (lastResult === 'interesse') {
      tips.ouverture = `"Bonjour ${nom}, suite a notre echange ou vous aviez montre de l'interet..."`;
      tips.conseils = ['Rappelez l\'offre qui l\'interessait', 'Proposez un RDV concret', 'Mentionnez un evenement ou menu saisonnier'];
    } else if (lastResult === 'rappeler') {
      tips.ouverture = `"Bonjour ${nom}, vous m'aviez demande de rappeler..."`;
      tips.conseils = ['Soyez bref — il/elle a deja ete contacte', 'Proposez une date precise', 'Si pas de reponse apres 3 relances, passez en mode email'];
    } else if (lastResult === 'absent' || lastResult === 'messagerie') {
      tips.ouverture = `"Bonjour ${nom}, je n'ai pas reussi a vous joindre la derniere fois..."`;
      tips.conseils = ['Essayez un autre horaire (matin/fin de journee)', 'Envoyez un email en complement', 'Laissez un message court et percutant'];
    } else if (lastResult === 'reflexion') {
      tips.ouverture = `"Bonjour ${nom}, je me permets de revenir vers vous suite a notre discussion..."`;
      tips.conseils = ['N\'insistez pas trop, restez disponible', 'Apportez un argument nouveau (promo, evenement)', 'Proposez un devis gratuit et sans engagement'];
    } else {
      tips.ouverture = `"Bonjour ${nom}, nous avons echange recemment concernant nos prestations traiteur..."`;
      tips.conseils = ['Faites reference au dernier echange', 'Apportez de la valeur ajoutee (nouveau menu, promo)', 'Soyez concis — max 2 min d\'appel'];
    }

    if (lastNotes) {
      tips.conseils.unshift(`Notes precedentes : "${lastNotes}"`);
    }

    tips.erreurs = ['Ne pas repartir de zero comme un premier contact', 'Ne pas etre trop insistant', 'Ne pas oublier de mentionner les echanges passes'];
  } else if (statut === 'contacte') {
    tips.contexte = `DEJA CONTACTE — ${nbComms} echange${nbComms > 1 ? 's' : ''}`;
    tips.ouverture = `"Bonjour ${nom}, je fais suite a notre premier echange..."`;
    tips.conseils = ['Resumez brievement votre premiere discussion', 'Apportez un element nouveau (promo, menu saisonnier)', 'Proposez un RDV ou une degustation', lastNotes ? `Notes : "${lastNotes}"` : ''].filter(Boolean);
    tips.erreurs = ['Ne pas oublier de mentionner le premier contact'];
  } else {
    tips.contexte = 'PREMIER CONTACT';
    tips.ouverture = `"Bonjour ${nom}, je suis Laurent du restaurant Le Mas a Saint-Laurent-de-la-Salanque..."`;
    tips.conseils = ['Presentez-vous brievement (Le Mas, cuisine catalane)', 'Identifiez leur besoin (CE, evenement, repas equipe)', 'Proposez une offre decouverte ou un devis gratuit', 'Soyez enthousiaste et a l\'ecoute'];
    tips.erreurs = ['Ne pas reciter un script, soyez naturel', 'Ne pas parler trop longtemps sans les ecouter'];
  }

  const secteurTips = {
    'immobilier': 'Ce secteur fait souvent des repas clients/inauguration',
    'banque-assurance': 'Pensez seminaires, CE, cadeaux clients fin d\'annee',
    'automobile': 'Lancements vehicules, repas equipe, evenements concession',
    'medical': 'Congres, journees equipe, pauses traiteur pour medecins',
    'btp': 'Repas chantier, inaugurations, soirees entreprise',
    'commerce': 'Animations commerciales, portes ouvertes, repas equipe',
    'tech': 'Team building, afterworks, repas livres au bureau',
    'association': 'Gala, soirees, buffets associatifs — budget souvent limite',
    'mairie': 'Receptions officielles, inaugurations, ceremonies',
    'education': 'Evenements scolaires, remises de diplome, fetes de fin d\'annee',
  };
  if (secteurTips[secteur]) {
    tips.conseils.push(`Secteur ${secteur} : ${secteurTips[secteur]}`);
  }

  return tips;
}
